import React, { } from 'react';
import { SideForm } from '../SideForms/SideForm';
import {
  TextInput,
  Form,
  FormGroup,
  TextInputSkeleton,
  TextAreaSkeleton,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Link,
  Column,
  Row,
  FormLabel,
  Slider,
  Checkbox,
  Loading
} from '@carbon/react';

import {
  useLazyGetOrganisationQuery,
  useUpdateOrganisationMutation,
  useCreateOrganisationMutation,
} from 'services/organisation';
import { SelectableGroups } from '../GroupsSelection/Groups';
import useForm from '@/lib/hooks/useForm';

const OrganisationForm = ({ id }) => {
  const [updateMutation, { isLoading: isUpdating }] = useUpdateOrganisationMutation();
  const [createMutation, { isLoading: isCreating }] = useCreateOrganisationMutation();
  const isSaving = isUpdating || isCreating;

  const {item: organisation, onChangeField, onSaveRequest, onCloseForm, unsaved, loading} = useForm({
    id,
    getLazy: useLazyGetOrganisationQuery,
    updateMutation,
    createMutation,
    defaultValues: {
      name: '',
      groups: [],
      additional_licences: 0,
      max_element_space: 1024,
      // Most operators don't pay from a separate billing address, so the
      // form starts with "billing identical to delivery" pre-checked. The
      // billing tab unlocks the moment the user opts out of that.
      billing_is_delivery_address: true,
      delivery_address: {
        name: '',
        street: '',
        postcode: '',
        city: '',
      },
      billing_address: {
        name: '',
        street: '',
        postcode: '',
        city: '',
      },
    }
  });

  const remove = (user) => {
    //confirmRemoveUser({ user })
  };

  let tabs = <></>;

  if (loading) {
    tabs = (

      <Tabs type="container">
        <TabList contained aria-label="">
          <Tab className="tab-content">
            Profil
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Form>
              <FormGroup legendText="">
                <TextInputSkeleton />
              </FormGroup>
              <FormGroup legendText="">
                <TextAreaSkeleton />
              </FormGroup>
            </Form>
          </TabPanel>
        </TabPanels>

      </Tabs>
    );
  } else {
    tabs = (
      <Tabs type="container">
        <TabList contained aria-label="">
          <Tab id="tab_default">
            Profil
          </Tab>
          <Tab id="tab_delivery">
            Lieferanschrift
          </Tab>
          <Tab id="tab_billing">
            Rechnungsanschrift
          </Tab>
          <Tab id="tab_license">
            Lizenzen
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel className="tab-content">
            <Form>
              <FormGroup legendText="">
                <TextInput
                  labelText="Organisation"
                  value={organisation.name}
                  id="form_organisation_name"
                  autoComplete="off"
                  invalid={organisation.name.length < 2}
                  invalidText={
                    'Sie müssen dem Betreiber einen Namen geben'
                  }
                  onChange={(e) =>
                    onChangeField('name', e.target.value)
                  }
                />
                <FormLabel>Gruppenzuweisung</FormLabel>
                <SelectableGroups selection={organisation.groups || []} onSelectionChange={(new_selection) => onChangeField('groups', new_selection)} />
              </FormGroup>
            </Form>
          </TabPanel>
          <TabPanel className="tab-content">
            <FormGroup legendText="Lieferadresse">
              <TextInput
                labelText="Adresse"
                value={organisation.delivery_address.name}
                id="form_location_address_name"
                autoComplete="off"
                onChange={(e) =>
                  onChangeField(
                    ['delivery_address', 'name'],
                    e.target.value
                  )
                }
              />
              <TextInput
                labelText="Straße"
                value={organisation.delivery_address.street}
                id="form_location_address_street"
                autoComplete="off"
                onChange={(e) =>
                  onChangeField(
                    ['delivery_address', 'street'],
                    e.target.value
                  )
                }
              />

              <Row>
                <Column sm={3} md={3} lg={3}>
                  <TextInput
                    labelText="PLZ"
                    value={organisation.delivery_address.postcode}
                    id="form_location_address_postcode"
                    autoComplete="off"
                    onChange={(e) =>
                      onChangeField(
                        ['delivery_address', 'postcode'],
                        e.target.value
                      )
                    }
                  />
                </Column>
                <Column>
                  <TextInput
                    labelText="Ort"
                    value={organisation.delivery_address.city}
                    id="form_location_address_city"
                    autoComplete="off"
                    onChange={(e) =>
                      onChangeField(
                        ['delivery_address', 'city'],
                        e.target.value
                      )
                    }
                  />
                </Column>
              </Row>
            </FormGroup>
          </TabPanel>
          <TabPanel className="tab-content">
            <FormGroup legendText="Rechnungsadresse">
              <Checkbox
                labelText="Rechnungsadresse ist mit Lieferadresse Identisch"
                id="form_billing_identical_to_delivery"
                checked={organisation.billing_is_delivery_address}
                value={organisation.billing_is_delivery_address}
                onChange={(_, {checked}) =>
                  onChangeField('billing_is_delivery_address', checked)
                }
              />
              <TextInput
                labelText="Adresse"
                value={
                  organisation.billing_is_delivery_address
                    ? organisation.delivery_address.name
                    : organisation.billing_address.name
                }
                id="form_billing_address_name"
                autoComplete="off"
                disabled={
                  organisation.billing_is_delivery_address
                }
                onChange={(e) =>
                  onChangeField(
                    ['billing_address', 'name'],
                    e.target.value
                  )
                }
              />
              <TextInput
                labelText="Straße"
                value={
                  organisation.billing_is_delivery_address
                    ? organisation.delivery_address.street
                    : organisation.billing_address.street
                }
                autoComplete="off"
                disabled={
                  organisation.billing_is_delivery_address
                }
                id="form_billing_address_street"
                onChange={(e) =>
                  onChangeField(
                    ['billing_address', 'street'],
                    e.target.value
                  )
                }
              />

              <Row>
                <Column sm={3} md={3} lg={3}>
                  <TextInput
                    labelText="PLZ"
                    value={
                      organisation.billing_is_delivery_address
                        ? organisation.delivery_address.postcode
                        : organisation.billing_address.postcode
                    }
                    autoComplete="off"
                    disabled={
                      organisation.billing_is_delivery_address
                    }
                    id="form_billing_address_postcode"
                    onChange={(e) =>
                      onChangeField(
                        ['billing_address', 'postcode'],
                        e.target.value
                      )
                    }
                  />
                </Column>
                <Column>
                  <TextInput
                    labelText="Ort"
                    value={
                      organisation.billing_is_delivery_address
                        ? organisation.delivery_address.city
                        : organisation.billing_address.city
                    }
                    autoComplete="off"
                    disabled={
                      organisation.billing_is_delivery_address
                    }
                    id="form_billing_address_city"
                    onChange={(e) =>
                      onChangeField(
                        ['billing_address', 'city'],
                        e.target.value
                      )
                    }
                  />
                </Column>
              </Row>
            </FormGroup>
          </TabPanel>
          <TabPanel className="tab-content">
            <FormGroup>
              <TextInput
                labelText="Maximale Speicher Größe (in MB)"
                value={organisation.max_element_space || 0}
                id="form_user_max_element_space"
                onChange={(e) =>
                  onChangeField('max_element_space', Number(e.target.value))
                }
              />

              <Slider
                labelText="Maximale kostenlose Anzahl Lizenzen"
                max={100}
                min={0}
                value={organisation.additional_licences || 0}
                onChange={(e) =>
                  onChangeField('additional_licences', Number(e.value))
                }
              />
            </FormGroup>
            {organisation.model.ID !== 'new' && (
              <>
                <hr />
                <Link href="#" onClick={() => remove(organisation)}>
                  Organisation löschen
                </Link>
              </>
            )}
          </TabPanel>
        </TabPanels>

      </Tabs>
    );
  }

  return (
    <SideForm
      title={id === 'new' ? 'Neue Organisation' : (loading ? '...' : organisation?.name)}
      subTitle="Organisation bearbeiten"
      onClose={onCloseForm}
      onSubmit={() => onSaveRequest(success => {})}
      primaryButton={'Speichern'}
      primaryButtonDisabled={!unsaved}
      secondaryButton={
        unsaved === true ? 'Abbruch' : 'Verlassen'
      }>
      {tabs}
      {(loading || isSaving) && <Loading />}
    </SideForm>
  );
};

export default OrganisationForm;
